import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-flexible-funeral-plan-cmb-v2.component.scss';
var FormItemFlexibleFuneralPlanCmbV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemFlexibleFuneralPlanCmbV2, _super);
    function FormItemFlexibleFuneralPlanCmbV2(element) {
        return _super.call(this, element) || this;
    }
    FormItemFlexibleFuneralPlanCmbV2.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.flexibleFuneralPlanCmbForm = this.element.querySelector('form');
        this.flexibleFuneralPlanCmbSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
    };
    FormItemFlexibleFuneralPlanCmbV2.prototype.bindEvents = function () {
        var _this = this;
        this.flexibleFuneralPlanCmbSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var formFields = _this.flexibleFuneralPlanCmbForm.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_this.flexibleFuneralPlanCmbForm.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.actionForm(_this.flexibleFuneralPlanCmbForm);
            }
        }); });
    };
    FormItemFlexibleFuneralPlanCmbV2.prototype.resetForm = function () {
        if (this.flexibleFuneralPlanCmbForm) {
            this.flexibleFuneralPlanCmbForm.reset();
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    FormItemFlexibleFuneralPlanCmbV2.prototype.actionForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        // additional containers
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        // fields
        var firstname = form.querySelector('input[name=first-name]');
        var lastname = form.querySelector('input[name=last-name]');
        var contact = form.querySelector('input[name=phone-number]');
        var email = form.querySelector('input[name=email-address]');
        // loader + hide form
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/services/FlexiFuneralInsuranceLeadsForm.jsp';
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var postData = '';
        // as per service
        if (firstname) {
            postData += 'firstname=' + firstname.value;
        }
        if (lastname) {
            postData += '&surname=' + lastname.value;
        }
        if (contact) {
            postData += '&contact=' + contact.value;
        }
        if (email) {
            postData += '&email=' + email.value;
        }
        postData += '&quoteNumber=';
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            loader.classList.remove('active');
            if (!response.data) {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                thankYou.classList.add('active');
                success.classList.remove('active');
                success.classList.add('hidden');
                error.classList.remove('hidden');
                error.classList.add('active');
            }
            else if ((response.data.toString().toLowerCase().includes('invalid')) || (response.data.toString().toLowerCase().includes('error'))) {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                thankYou.classList.add('active');
                success.classList.remove('active');
                success.classList.add('hidden');
                error.classList.remove('hidden');
                error.classList.add('active');
            }
            else {
                if (response.code) {
                    analyticsService.dtmFormComplete('complete', response.code, false, "", email.value, contact.value);
                }
                else if (response.status) {
                    analyticsService.dtmFormComplete('complete', response.status, false, "", email.value, contact.value);
                }
                else {
                    analyticsService.dtmFormComplete('complete', '200', false, "", email.value, contact.value);
                }
                thankYou.classList.add('active');
                error.classList.remove('active');
                error.classList.add('hidden');
                success.classList.remove('hidden');
                success.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    return FormItemFlexibleFuneralPlanCmbV2;
}(Base));
export { FormItemFlexibleFuneralPlanCmbV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-flexible-funeral-plan-cmb-v2/form-item-flexible-funeral-plan-cmb-v2.component.ts
// module id = 889
// module chunks = 0